import Vue from 'vue'

function fixJson (site) {
  if (Object.prototype.toString.call(site.json) !== '[object Object]') {
    site.json = {
      url: '',
      gtm_id: '',
      group_in_slug: false
    }
  }
}

// Might want to change it to UUID
const indexBy = 'slug'

// Site mutations
const mutations = {
  SET (state, sites = []) {
    state.sites = {}
    sites.forEach(site => {
      fixJson(site)
      Vue.set(state.sites, site[indexBy], site)
    })
  },

  // Add new site to store
  ADD (state, site) {
    fixJson(site)
    Vue.set(state.sites, site[indexBy], site)
  },

  REMOVE (state, site) {
    Vue.set(state.sites[site[indexBy]], 'deleted_at', (new Date()).toISOString())
  },

  // Make site active
  SET_ACTIVE (state, key = null) {
    state.active = state.sites[key]
  },

  SET_NEW (state, site) {
    state.newSite = site
  },

  UPDATE_NEW ({ newSite }, { key, value }) {
    Vue.set(newSite, key, value)
  },

  CLEAR_NEW ({ newSite }) {
    Object.keys(newSite).forEach(key => {
      newSite[key] = ''
    })
    fixJson(newSite)
  },

  RESTORE (state, site) {
    Vue.set(state.sites[site[indexBy]], 'deleted_at', null)
  },

  SET_ALL_SITES (state, sites) {
    Vue.set(state, 'allSites', sites)
  }
}

export default mutations
